import { useSelector } from 'react-redux';
import { gameDetailsDataSelector, gameDetailsIsLoadingSelector } from 'modules/games/store/selectors';

export const useGameDetails = () => {
  const isLoading = useSelector(gameDetailsIsLoadingSelector);
  const data = useSelector(gameDetailsDataSelector);

  return {
    isLoading,
    data,
  };
};
